module.exports = __webpack_public_path__ + "img/ico-search-white.3b726f05.svg";